import { render, staticRenderFns } from "./LoteProductos.vue?vue&type=template&id=53a4398d&"
import script from "./LoteProductos.vue?vue&type=script&lang=js&"
export * from "./LoteProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports